import React, { Component } from 'react';
import WallColor from './WallColor/WallColor';
import TrimColor from './TrimColor/TrimColor';
import RoofColor from './RoofColor/RoofColor';
import DoorColor from './DoorColor/DoorColor';
import Accordion from 'react-bootstrap/Accordion';
import { Checkbox } from '@rmwc/checkbox';
import Scrollbar from "react-scrollbars-custom";
import { connect } from "react-redux";
import { Tab, Nav } from 'react-bootstrap';
import * as actionCreator from "../../../action/index.js";
import WainscotColor from './WainscotColor/WainscotColor';
import ReadMore  from '../../ReadMore'
import { getImage } from '../../../redux/reducers/utils.js';
// import * as cuComponent from '../../../redux/reducers/componentReducer';
class BuildingColors extends Component {
   constructor(props) {
      super(props);
      this.state = {
         showWainscotdata: false,
      };
  
    }

   TsCeSot = (Val) => {
      this.props.const_var.checkIval = 0;
      // cuComponent.TsCeSot(Val);
      this.props.handleShow();
   }
   // handleWainscotAccordion=()=>{
      // let selectedTab = this.props.params.wainscotTexture;
      // if(this.props.params.wainscotTexture.includes("stackstone")) selectedTab = "stackstone";
      // if(this.props.params.wainscotTexture == "none" || this.props.params.wainscotTexture == "vertical" ) selectedTab = "metal";
      // let allSections = document.querySelectorAll('.color-accordion .card');
      // let sections = document.querySelectorAll(`.color-accordion .card.${selectedTab}`);
      // if(allSections){
      //    allSections.forEach((el) => {
      //       if(el?.classList.contains('active')){
      //          el?.classList.remove('active')
      //          el?.childNodes[1]?.classList.remove('show')
      //       }
      //    })
      // }
      // if(sections){
      //    sections[0]?.classList.add('active')
      //    sections[0]?.childNodes[1]?.classList.add('show')
      // }
   //  }
   render() {
      if(!this.props?.const_var?.color) return;
      let premiumColors = this.props.const_var.color.filter((val) => (val.color_add_ons != undefined ? val.color_add_ons.length !=0 : val.cost != 0));
      let wainscotImg = getImage(this.props.params.wainscotTexture);
      let wallImg = getImage(this.props.params.wallTexture);
    
      return (

         <div className="building-elements-sec">
            <div className="building-elements-sec-mid">
               <div className="building-elements-sec-mid-scroll">
                  <form className=''>
                     <div className="section-seprator">
                        <Tab.Container defaultActiveKey="roofColor">
                           <Nav variant="tabs" className="nav-tab-line">
                              <Nav.Item className='nav-item-line'>
                                 <Nav.Link eventKey="roofColor" className='nav-link-line' onClick={(e) =>{this.setState({showWainscotdata: false})}}>
                                    <span className='icon'>
                                       <span className="color-switch-code" style={{ background: this.props.params.p_r_c.replace("0x", "#") }}></span>
                                    </span> 
                                    <span className='text'>Roof</span>
                                 </Nav.Link>
                              </Nav.Item>
                              {this.props.checkWall != "Fully Opened" ?
                              <Nav.Item className='nav-item-line'>
                                 <Nav.Link eventKey="wallColor" className='nav-link-line'  onClick={(e) =>{this.setState({showWainscotdata: false})}}>
                                    <span className='icon'>
                                       <span className="color-switch-code force-applied" style={{ background: this.props.params.p_w_c.replace("0x", "#"), backgroundImage:`url(${process.env.REACT_APP_BASE_URL + wallImg})` }}></span>
                                    </span> 
                                    <span className='text'>Wall</span>
                                 </Nav.Link>
                              </Nav.Item>:null} 
                              <Nav.Item className='nav-item-line'>
                                 <Nav.Link eventKey="trimColor" className='nav-link-line'  onClick={(e) =>{this.setState({showWainscotdata: false})}}>
                                    <span className='icon'>
                                       <span className="color-switch-code" style={{ background: this.props.params.p_t_c.replace("0x", "#") }}></span>
                                    </span> 
                                    <span className='text'>Trim</span>
                                 </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className='nav-item-line'>
                                 <Nav.Link eventKey="WainscotColor" className='nav-link-line' onClick={(e) =>{this.setState({showWainscotdata: true})} /*  this.handleWainscotAccordion() */}>
                                    
                                    {
                                       this.props.params.p_w_c_n == true
                                       ?
                                       <span className='icon'>
                                          <span className="color-switch-code force-applied" style={{background: this.props.params.p_w_c_c.replace("0x", "#"), backgroundImage:`url(${process.env.REACT_APP_BASE_URL + wainscotImg})` }}></span>
                                       </span>   
                                       :
                                       <span className="icon icon-round-close"><span className="path1"></span><span className="path2"></span></span>
                                    }
                                    <span className='text'>Wainscot</span>
                                 </Nav.Link>
                              </Nav.Item>
                           </Nav>
                           <Tab.Content className='tab-content-line'>
                              <Tab.Pane className='tab-pane-line' eventKey="roofColor">
                                 <div className='card-body-inner'>
                                    <RoofColor />
                                 </div>
                              </Tab.Pane>
                              <Tab.Pane className='tab-pane-line' eventKey="wallColor">
                                 <div className='card-body-inner'>
                                    {(this.props.checkWall != "Fully Opened") ?
                                       <WallColor />
                                       : null
                                    }
                                 </div>
                              </Tab.Pane>
                              <Tab.Pane className='tab-pane-line' eventKey="trimColor">
                                 <div className='card-body-inner'>
                                    <TrimColor />
                                 </div>
                              </Tab.Pane>
                              <Tab.Pane className='tab-pane-line' eventKey="WainscotColor">
                                 <div className='card-body-inner'>
                                    {
                                       this.state.showWainscotdata &&
                                       <WainscotColor />
                                    }
                                 </div>
                              </Tab.Pane>
                           </Tab.Content>
                        </Tab.Container>

                        <div className='read-box d-none'>
                           <ReadMore>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</ReadMore>
                        </div>
                     </div>
                  </form>                     

                  {/* {(this.props.const_var.loginSession != true) ?
                  <>
                  <p>Due to the variations in monitors and browsers, the color samples displayed on this tool may appear different on different monitors and devices. </p>
                  <p>Computer monitors are not all calibrated equally and color reproduction on the Internet is not precise. Since it is not possible to guarantee our online colors will look the same on all computers, we do not guarantee that what you see accurately portrays the color of the actual color of the Sheet Metal.</p>
                  <p>We do our very best to make sure our samples are as close to the exact product as possible, but cannot guarantee that what you see is an exact sample. If it is important that the sample be exact, it is highly recommended that once you contact us. </p>
                  </>
                  : null} */}
               </div>
            </div>
         </div>
      );
   }
}
const mapStoreToProps = (state) => {
   return state.reducer
}
export default connect(
   mapStoreToProps,
   actionCreator
)(BuildingColors);